export default __webpack_public_path__ + "static/media/sql.e423b86d.PNG";